import React, { useRef, useState } from "react";
import {
  Button,
  Checkbox,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SelectComponent from "../components/core/SelectComponent";
import Header from "../components/core/Header";
import { getResponseLogReport } from "../utils/API";
import CustomTable from "../components/core/CustomTable";
import moment from "moment";
import LoadingComponent from "../components/core/LoadingComponent";
import { SmallLightTooltip } from "../components/core/Tooltip";

import { showToast } from "../utils/tostr";
const entitylist = [
  {
    displayName: "PML",
    id: "pml",
  },
  {
    displayName: "Bill & Tariff",
    id: "tariff",
  },
  {
    displayName: "vNeuron",
    id: "vneuron",
  },
];

function ResponseLogReport() {
  const [selectEntity, setSelectEntity] = useState("");
  const [showHistory, setShowHistory] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoaing] = useState(false);
  const claimId = useRef();
  const [hoveredRowIndexResponse, setHoveredRowIndexResponse] = useState(-1);
  const [hoveredRowIndexRequest, setHoveredRowIndexRequest] = useState(-1);

  const handleFetch = async () => {
    setLoaing(true);
    const response = await getResponseLogReport(
      selectEntity,
      claimId.current.value,
      showHistory
    );
    setTableData(
      Array.isArray(response.data) ? response.data : [response.data]
    );
    setLoaing(false);
  };

  const handleCellHoverResponse = (rowIndex) => {
    setHoveredRowIndexResponse(rowIndex);
  };
  const handleCellHoverRequest = (rowIndex) => {
    setHoveredRowIndexRequest(rowIndex);
  };
  const handleCopyClick = (text, type) => {
    navigator.clipboard.writeText(text.toString());
    showToast("Copied " + type, "success", null, 1000);
  };

  const tableColumn = [
    // {
    //   title: "Claim Data Id",
    //   field: "claimDataId",
    // },
    {
      title: "Creation Date",
      field: "dateCreated",
      render: (rowData) =>
        rowData &&
        rowData.dateCreated && (
          <span>
            {" "}
            {moment(rowData.dateCreated)
              .tz("Asia/Kolkata")
              .format("DD- MM -YYYY, hh:mm:ss a")}{" "}
          </span>
        ),
    },
    {
      title: "Updated Date",
      field: "dateUpdated",
      render: (rowData) =>
        rowData &&
        rowData.dateUpdated && (
          <span>
            {" "}
            {moment(rowData.dateUpdated)
              .tz("Asia/Kolkata")
              .format("DD- MM -YYYY, hh:mm:ss a")}{" "}
          </span>
        ),
    },
    {
      title: "Request",
      field: "request",
      render: (rowData, index) =>
        rowData &&
        rowData.request && (
          <div
            style={{ width: "450px", height: "300px", overflow: "auto" }}
            onMouseEnter={() => handleCellHoverRequest(index)}
            onMouseLeave={() => handleCellHoverRequest(-1)}
          >
            <div className="copy-icon-container">
              {hoveredRowIndexRequest === index && (
                <span
                  className="copy-icon"
                  onClick={() =>
                    handleCopyClick(rowData.request.toString(), "Request Body")
                  }
                >
                  📋
                </span>
              )}
            </div>
            <pre
              style={{ whiteSpace: "wrap", wordBreak: "break-word" }}
              className="copy-text"
            >
              {rowData.request.toString()}
            </pre>
          </div>
        ),
    },
    {
      title: "Response",
      field: "response",
      render: (rowData, index) =>
        rowData &&
        rowData.response && (
          <div
            style={{ width: "450px", height: "300px", overflow: "auto" }}
            onMouseEnter={() => handleCellHoverResponse(index)}
            onMouseLeave={() => handleCellHoverResponse(-1)}
          >
            <div className="copy-icon-container">
              {hoveredRowIndexResponse === index && (
                <span
                  className="copy-icon"
                  onClick={() =>
                    handleCopyClick(
                      rowData.response.toString(),
                      "Response Body"
                    )
                  }
                >
                  📋
                </span>
              )}
            </div>
            <pre
              style={{ whiteSpace: "wrap", wordBreak: "break-word" }}
              className="copy-text"
            >
              {rowData.response.toString()}
            </pre>
          </div>
        ),
    },
    {
      title: "Status",
      field: "status",
    },
  ];

  return (
    <Grid container style={{ width: "100%" }}>
      <Header />
      <div
        style={backButtonDiv}
      >
        <div style={{ color: "#fff" }}>
          <ArrowBackIcon />
        </div>

        <Link to={"/"} style={{ textDecoration: "none", color: "#fff" }}>
          {" "}
          Go Back
        </Link>
      </div>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
        padding={3}
      >
        <Typography variant="body1">Request and Response Log Report</Typography>
      </Grid>

      <Paper
        item
        style={infoBar}
      >
        <Grid style={{ marginTop: 5 }}>
          <SelectComponent
            menuItem={entitylist}
            label={"Entity to search"}
            setSelections={setSelectEntity}
            minWidth="300px"
            mode="search"
          />
        </Grid>
        <SmallLightTooltip
          title={
            "Id which is available in claim URL or you can get it in claim listing table"
          }
          placement="top"
        >
          <Grid style={{ width: "300px" }}>
            <TextField
              variant="standard"
              margin="normal"
              required
              fullWidth
              id="claimId"
              label="Claim Portal Id"
              name="claimId"
              autoComplete="name"
              autoFocus
              inputRef={claimId}
            />
          </Grid>
        </SmallLightTooltip>

        <Grid style={{ marginTop: 30 }}>
          <Checkbox
            checked={showHistory}
            onChange={(event) => setShowHistory(event.target.checked)}
            inputProps={{ "aria-label": "controlled" }}
          />
          <label>Wanna fetch it's history too</label>
        </Grid>
        <Grid style={{ marginTop: 20 }}>
          <Button
            variant="contained"
            style={{ padding: "10px" }}
            onClick={handleFetch}
            disabled={selectEntity !== "" ? false : true}
          >
            {" "}
            Search
          </Button>
        </Grid>
      </Paper>
      <Grid style={{ width: "100%", margin: 20 }}>
        {loading === true ? (
          <LoadingComponent />
        ) : (
          <CustomTable
            tableColumns={tableColumn}
            tableData={tableData}
            isPagination={false}
            noStickyHeader={true}
          />
        )}
      </Grid>
    </Grid>
  );
}

export default ResponseLogReport;
export const backButtonDiv = {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    border: "1px solid",
    padding: 10,
    height: "1.5rem",
    marginLeft: 30,
    marginTop: 10,
    background: "#000",
    cursor: "pointer",
}

export const infoBar = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    justifyItems: "space-between",
    gap: 40,
    width: "100%",
    margin: 20,
    padding: "10px",
}